import OrganisationActionsContext, { OrganisationActionsContextType } from "contexts/OrganisationActionsContext";
import useDefinedContext from "hooks/useDefinedContext";

function useOrganisationActions(): OrganisationActionsContextType {
  return useDefinedContext(OrganisationActionsContext);
}

export default useOrganisationActions;
